import { Box, Container, Stack, Typography, useTheme } from '@mui/material'
import { useNavigate } from 'react-router'
import { ContainedButton } from '../../../../../components/Button'
import RefreshIcon from '@mui/icons-material/Refresh'

export const EmptyResults = () => {
  const theme = useTheme()
  const navigate = useNavigate()

  const handleTryAgain = () => {
    navigate('/test-strip/upload')
  }

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        minHeight: 'calc(100vh - 68px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Container maxWidth="sm">
        <Stack gap={1} alignItems="center" textAlign="center">
          <Typography
            fontSize={'2.2rem'}
            fontWeight={theme.typography.fontWeightBold}
            color='text.primary'
          >
            No Results Found
          </Typography>
          <Typography fontSize={'1rem'} color={theme.palette.grey[600]}>
            There are no analysis results available. Please try analyzing a test strip.
          </Typography>
          <ContainedButton
            size='large'
            onClick={handleTryAgain}
            startIcon={<RefreshIcon />}
            sx={{
              mt: 2,
            }}
          >
            Analyze Test Strip
          </ContainedButton>
        </Stack>
      </Container>
    </Box>
  )
}